module.exports = __webpack_public_path__ + "img/growthAbility5.e075e885.png";